import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CoreConfig } from './../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { useScreenOrientation } from '../../Hooks/UseOrientation';
import { AnimatedView } from './AnimatedView';
export const ContainerView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.container,
    style: {
        overlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        },
        container: {
            flex: 1,
            padding: 20,
        }
    }
})(({ style, containerStyle, cache, image, children, removeSkeleton, removePaddingHorizontal }) => {
    var _a;
    const { offset, isLandscape } = useScreenOrientation();
    let paddingHorizontal = ((_a = style === null || style === void 0 ? void 0 : style.container) === null || _a === void 0 ? void 0 : _a.padding) || 0;
    if (removePaddingHorizontal) {
        paddingHorizontal = 0;
    }
    const overrideContainerStyle = isLandscape
        ? { paddingStart: paddingHorizontal + offset.left, paddingEnd: paddingHorizontal + offset.right }
        : { paddingStart: paddingHorizontal, paddingEnd: paddingHorizontal };
    return (_jsxs(AnimatedView, { style: [style === null || style === void 0 ? void 0 : style.container, overrideContainerStyle, containerStyle], children: [!!image && (_jsx(AnimatedImageView, { removeSkeleton: removeSkeleton, image: image, cache: cache, containerStyle: style === null || style === void 0 ? void 0 : style.overlay, resizeMode: "cover" })), children] }));
});
